
import React from 'react'

export default function PolygonPurpleLine() { return (<svg width="147" height="146" viewBox="0 0 147 146" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.44531 144.822L1.44531 1.64998L144.904 144.822L1.44531 144.822Z" stroke="#9E19EF"/>
</svg>)}
